/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Link_FailedInputs */



/**
* | output |
* | --- |
* | "Access was refused, or your administrator has to approve it first. Try again." |
*
* @param {Connections_Link_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_link_failed = /** @type {((inputs?: Connections_Link_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Link_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De toegang werd geweigerd, of je beheerder moet ze eerst goedkeuren. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'accès a été refusé, ou votre administrateur doit d'abord l'approuver. Réessayez.")
	return /** @type {LocalizedString} */ ("Access was refused, or your administrator has to approve it first. Try again.")
});